var pickerArray = [];
var filesArray = [];


$.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
};

function enableSubmit() {
    $(".jautajums-brokerim").attr("disabled", "");
    $(".jautajums-brokerim").prop("disabled", false);
}


function changeColors() {
    const colors = ['rgb(45, 194, 107)', '#ff8590', '#ffee52', '#a7e16c', '#60dded', '#b27bf3', '']; // Define your colors
    const elements = $('.glow_after_animation'); // Select elements
    let colorIndex = 0; // Start index for colors
    const totalChanges = colors.length; // Total number of color changes
    let changeCount = 0; // Track number of changes

    // Apply CSS transition to elements for smooth color change
    elements.css('transition', 'color 0.5s ease'); // Change the duration and easing function as needed

    function updateColor() {

        if (changeCount >= totalChanges) {
            return; // Stop if all color changes are done
        }

        // Get the next color and apply it
        const color = colors[colorIndex];
        elements.css('color', color);
        colorIndex = (colorIndex + 1) % colors.length; // Move to the next color
        changeCount++; // Increment change count

        // Schedule the next color change
        setTimeout(updateColor, 200); // Change color every 500 milliseconds
    }

    // Start the color change process
    updateColor();
}

var run_once = false;

function drawBeeAnimation() {
    const canvaz = document.querySelector('.canvaz');
    if (!canvaz) {
        console.error('canvaz element not found.');
        return;
    }

    const ctx = canvaz.getContext('2d');
    if (!ctx) {
        console.error('Failed to get 2D context.');
        return;
    }

    const beeImage = new Image();
    beeImage.src = 'frontend/img/bee2.png'; // Image URL

    const bee = {
        x: 0,
        y: 0,
        width: 40,
        height: 40,
        rotationOffset: 180,
        xOffset: 0,
        yOffset: -15
    };

    const stars = [];
    const radius = 210;
    const padding = 20;
    const centerX = padding + radius;
    const centerY = padding + radius;

    let angle = 270;
    const speed = 0.3;
    const maxAngle = 360 + 210;
    let globalOpacity = 1;
    let frameCounter = 0;

    const rainbowColors = ['#ff8590', '#ffee52', '#a7e16c', '#60dded', '#b27bf3'];
    const colorRepeatCount = 8;
    let colorIndex = 0;
    let colorCycleCounter = 0;

    function getRainbowColor() {
        if (colorCycleCounter >= colorRepeatCount) {
            colorIndex = (colorIndex + 1) % rainbowColors.length;
            colorCycleCounter = 0;
        }
        colorCycleCounter++;
        return rainbowColors[colorIndex];
    }

    function drawBee() {
        ctx.save();
        ctx.translate(bee.x, bee.y);
        const rotationAngle = angle * (Math.PI / 180);
        ctx.rotate(rotationAngle + (bee.rotationOffset * Math.PI / 180));
        ctx.globalAlpha = globalOpacity;
        ctx.drawImage(beeImage, -bee.width / 2 + bee.xOffset, -bee.height / 2 + bee.yOffset, bee.width, bee.height);
        ctx.restore();
    }

    function drawStar(star) {
        ctx.save();
        ctx.translate(star.x, star.y);
        ctx.rotate(star.rotation);
        ctx.beginPath();
        ctx.moveTo(0, -star.size / 2);
        ctx.lineTo(star.size / 2, star.size / 2);
        ctx.lineTo(-star.size / 2, star.size / 2);
        ctx.closePath();
        ctx.fillStyle = star.color;
        ctx.globalAlpha = star.opacity * globalOpacity;
        ctx.fill();
        ctx.restore();
    }

    function animate() {
        ctx.clearRect(0, 0, canvaz.width, canvaz.height);

        if (angle < maxAngle) {
            angle += speed;
            const radians = angle * (Math.PI / 180);
            bee.x = centerX + radius * Math.cos(radians);
            bee.y = centerY + radius * Math.sin(radians);

            if (frameCounter % 5 === 0) { // Adjusted frame rate for adding stars
                stars.push({
                    x: bee.x + Math.random() * 10 - 5,
                    y: bee.y + Math.random() * 10 - 5,
                    size: 5,
                    color: getRainbowColor(),
                    opacity: 1,
                    rotation: Math.random() * Math.PI
                });
            }
        } else {
            globalOpacity -= 0.003;
            if (globalOpacity < 0) {
                globalOpacity = 0;
            }
            // jQuery color change example
            if (run_once == false) {
                run_once = true;
                changeColors();
            }
        }

        if (beeImage.complete) {
            drawBee();
        }

        for (let i = stars.length - 1; i >= 0; i--) {
            const star = stars[i];
            drawStar(star);
            star.size += 0.1;
            star.opacity -= 0.005;
            if (star.opacity <= 0) {
                stars.splice(i, 1);
            }
        }

        if (angle <= maxAngle || globalOpacity > 0) {
            requestAnimationFrame(animate);
        }

        frameCounter++;
    }

    beeImage.onload = function () {
        animate();
    };
}

$(document).ready(function() {

    if($("#menu>li").first().hasClass("active")){
        const left_pos = 100; // change as needed

        const $canvas = $('<canvas>', {
            class: 'canvaz',
            css: {
                position: 'absolute',
                zIndex: 999,
                pointerEvents: 'none',
                top: '-90px',
                left: left_pos + 'px'
            }
        });
        $canvas.attr('width', 500);
        $canvas.attr('height', 500);

        const $lastLi = $('#menu>li:first-child');
        if ($lastLi.length) {
            $lastLi.append($canvas); // insert inside last <li>
        }

        drawBeeAnimation();
    }


    $("select").on("change", function () {
        if ($(this).find("[data-url]").length) {
            var selectedOption = $(this).find("option:selected"); // Get selected option
            var url = selectedOption.data("url"); // Get the URL from the selected option
            location.href = url; // Redirect to the URL
        }


    });
});
$(document).ready(function () {

    $(".v-popup").click(function (e) {
        e.preventDefault();
        if ($(this).data("popup-classes")) {
            $("#v-popup").attr("class", $(this).data("popup-classes"));
        }

        $("#v-popup").addClass("active");

        if ($(this).data("popup-url")) {
            $.post($(this).data("popup-url"), { back_link: $(location).attr("pathname") }, function (data) {
                $("#v-popup .content").html(data);

                $(".cancel-vpopup").click(function (e) {
                    $("#v-popup .content").html("");
                    $("#v-popup").removeClass("active");
                });
            });
        }
    })


    var renewUserId = null;

    $(".renew-user").click(function () {
        $("#renew-user").css("display", "flex").hide().fadeIn();
        renewUserId = $(this).closest("tr").data("id");
    });

    $(".renew-user-box .submit").on("click", function () {
        $("#renew-user").fadeOut().removeClass("active");
        $.post("room/renew_user.php", { uid: renewUserId }, function () {
            location.reload();
        });
    });

    $(".renew-user-hide").on("click", function (e) {
        e.preventDefault();
        $("#renew-user").fadeOut().removeClass("active");
    });

    $(".apstiprinat-apdrsinasanas-btn").on("click", function () {
        if ($(this).find(".apstiprinat-apdrsinasanas").is(":disabled")) {
            $("#error").css("display", "flex").hide().fadeIn();
        }
    });

    $("span.close").on("click", function () {
        $(this).parent().parent().hide();
    });

    $(".mekletajs input").on("input", function () {
        var modd = "";
        var linkk = "";

        if ($(this).closest("[data-mod='darbinieks'").length) {
            //modd = "darbinieks";
            //linkk = "darbinieks";
        } else if ($(this).closest("[data-mod='darbinieks_atskaite'").length) {
            //modd = "darbinieks";
            //linkk = "atskaites_darbinieks";
        } else if ($(this).closest("[data-mod='atskaites_apdrosinasana'").length) {
            //modd = "atskaites_apdrosinasana";
            //linkk = "atskaites_apdrosinasana";
        } else if ($(this).closest("[data-mod='apdrosinasana_apdrosinasana'").length) {
            //modd = "apdrosinasana_apdrosinasana";
            //linkk = "apdrosinasana";
        } else {
            //return false;
        }
        linkk = $(this).closest("[data-url]").data("url");


        var fd = new FormData();
        fd.append("modulis", modd);
        fd.append("darba_nemejs_pozicija_id", $(this).closest(".mekletajs").data("darba_nemejs_pozicija_id"));

        if (linkk == "atskaites_apdrosinasana") {
            fd.append("seo_link", $(this).closest("tr").data("seo_link"));
        } else if (linkk == "atskaites_darbinieks") {
            fd.append("seo_link", $(this).closest("tr").data("seo_link"));
        } else if (linkk == "apdrosinasana") {
            fd.append("seo_link", $(this).closest("tr").data("seo_link"));
        }

        pn = $(this).closest("tr").data("pn");

        fd.append("pn", pn);

        $(this)
            .closest("tr")
            .find(".mekletajs input")
            .each(function () {
                fd.append($(this).attr("name"), $(this).val());
            });

        $.ajax({
            url: linkk,
            data: fd,
            processData: false,
            contentType: false,
            type: "POST",
            success: function (data) {
                $("tbody tr:not(:first-child)").remove();

                $(data).insertAfter($("tbody tr:first-child"));

                dzestDarb();
                tdClick();
                test23();
                //insurance_who();
                //redzIzmaksass(); -- so nevajag jo tad bug
            },
        });
    });



    $(".delete-user-a").on("click", function () {
        $("#popup-error").data("family-member-id", $(this).closest(".family-member-js").data("id"));
        $("#popup-error").css("display", "flex").hide().fadeIn();
    });
    $(".popup-error-box .submit").on("click", function () {
        $("#popup-error").fadeOut().removeClass("active");

        $.post("room/delete_family_member.php", { family_member_id: $("#popup-error").data("family-member-id") }, function () {
            $("#popup-error").fadeOut().removeClass("active");
            $(".family-member-js[data-id=" + $("#popup-error").data("family-member-id") + "]").remove();
            location.reload();
        });
    });
    $(".popup-error-hide").on("click", function (e) {
        e.preventDefault();
        $("#popup-error").fadeOut().removeClass("active");
    });

    var readEventInterva = null;

    function smartID(form) {
        $("#smartid").removeClass("d-none").addClass("d-flex");
        $("#smartid").show();

        var pk = $(form).find('[name="personas_kods"]').val();

        $.post("", {login: "smartid", personas_kods: pk }, function (data) {
            if (data == "DEMO") {
                location.reload();
            } else {
                $("#info img").remove();
                $("#info span").show();
                $("#info span").text(data);
                if (!$.isNumeric(data)) {
                    $("#info span").addClass("error");
                } else {
                    $("#info span").removeClass("error");

                    clearInterval(readEventInterva);

                    //lasam info no eventa
                    readEventInterva = setInterval(function () {
                        $.post("", {login: "smartid_event"}, function (data) {
                            if (data == "COMPLETE") {
                                location.reload();
                            } else if (data != "RUNNING") {
                                clearInterval(readEventInterva);
                                $("#info span").addClass("error");
                                $("#info span").text(data);
                            }
                        });
                    }, 2000);
                }
            }
        });
    }

    $("body").on("submit","#personas-form", function (e) {
        e.preventDefault();
        $("#v-popup").removeClass("active");
        var form = $(this);
        smartID(form);
        return false;
    });

    $("body").on("submit","#twofa-form", function (e) {
        e.preventDefault();

        $.post($(this).attr("action"), $(this).serialize(), function (data) {
            if(data === "COMPLETE") {
                location.reload();
                return false;
            }
            $("#v-popup .content").html(data);
        });

        return false;
    });

    $("body").on("click", ".open-popup", function () {
        $("#v-popup").addClass("active");

        $.get($(this).data("open-popup"), {}, function (data) {
            $("#v-popup .content").html(data);
        });
    })

    $("body").on("click", ".close-popup", function () {
        $("#v-popup").removeClass("active");
        $("#v-popup .content").html("");
    })

    // $(".login").on("click", function (e) {
    //     e.preventDefault();
    //     var form = $(this).closest("form");
    //     smartID(form);
    //     return false;
    // });

    $("body").on("click", ".tab-show", function () {
        var el = $(this).data("tab-show");
        $(this).removeClass("d-block").addClass("d-none");
        $(el).show();
        $(el).find("input").focus();
    });

    function caclulateSumm() {
        $(".add-g")
            .find("input")
            .unbind("keyup")
            .on("keyup", function () {
                confirmApdrDisableStatus();
            });

        $(".box-style-1.active .form-check-input")
            .unbind("change")
            .on("change", function () {
                if ($(this).closest(".add-g").length) {
                    //vai visiem kuriem checked ir aipiditi visi lauki?
                    var viss_aizpildits = true;
                    $(".add-g .form-check-input:checked").each(function () {
                        $(this)
                            .closest(".add-g")
                            .find("input[type='text']")
                            .each(function () {
                                if (!$(this).val()) {
                                    viss_aizpildits = false;
                                }
                            });
                    });

                    if (!viss_aizpildits) {
                        $(".apstiprinat-apdrsinasanas").attr("disabled", "disabled");
                        $(".apstiprinat-apdrsinasanas").prop("disabled", true);
                    } else {
                        $(".apstiprinat-apdrsinasanas").attr("disabled", "");
                        $(".apstiprinat-apdrsinasanas").prop("disabled", false);
                    }
                }

                var id = $(this).closest(".box-style-1").data("id");
                var summ = 0;
                var summ_family = 0;
                var summ_2 = 0;
                var summ_family_2 = [];

                $(".box-style-1.active[data-id='" + id + "'] .form-check-input:not(.green)").each(function () {
                    let cik = 0;

                    if (!$(this).closest(".add-g").length) {
                        cik = $(this).parent().parent().find(".float-end.nosss2").text();

                        cik = cik.replace("+ ", "");

                        if ($(this).is(":checked") && cik) {
                            summ += parseFloat(cik);
                        }
                    } else {
                        cik = $(this).parent().parent().find(".float-end.nosss2").text();

                        cik = cik.replace("+ ", "");

                        if ($(this).is(":checked") && cik) {
                            summ_family += parseFloat(cik);
                        }
                    }
                });

                $('.summ[data-id="' + id + '"]').text(summ.toFixed(2));

                if (summ_family > 0) $('.summ_family[data-id="' + id + '"]').text(" + " + summ_family.toFixed(2));
                else $('.summ_family[data-id="' + id + '"]').text("");

                $(".box-style-1.active .form-check-input:not(.green)").each(function () {
                    let cik = 0;
                    if (!$(this).closest(".add-g").length) {
                        cik = $(this).parent().parent().find(".float-end.nosss2").text();

                        cik = cik.replace("+ ", "");

                        if ($(this).is(":checked") && cik) {
                            summ_2 += parseFloat(cik);
                        }
                    } else {
                        cik = $(this).parent().parent().find(".float-end.nosss2").text();

                        cik = cik.replace("+ ", "");

                        if ($(this).is(":checked") && cik) {
                            var u_id = $(this).parent().parent().find(".select-family-member").val();
                            summ_family_2.push({ family_id: u_id, price: cik });
                        }
                    }
                });

                $("table .summ2:not(.family-member)").text(summ_2.toFixed(2));

                $("table.for-family-member").each(function () {
                    var self = this;
                    var kopsumma = 0;
                    summ_family_2.forEach(function (element) {
                        if (element.family_id == $(self).data("family_id")) {
                            kopsumma += parseFloat(element.price);
                        }
                    });
                    $(this).find(".summ2").text(kopsumma.toFixed(2));

                    //ejam cauri visiem apdrosinatajiem
                    $(this)
                        .find(".summ")
                        .each(function () {
                            var self2 = this;
                            var id = $(this).data("id");

                            summ_family = 0;
                            $(".box-style-1.active[data-id='" + id + "'] .form-check-input:not(.green)").each(function () {
                                let cik = 0;

                                if ($(this).closest(".add-g").length) {
                                    cik = $(this).parent().parent().find(".float-end.nosss2").text();

                                    cik = cik.replace("+ ", "");

                                    if ($(this).is(":checked") && cik) {
                                        var u_id = $(this).parent().parent().find(".select-family-member").val();
                                        if (u_id == $(self2).closest(".for-family-member").data("family_id")) summ_family += parseFloat(cik);
                                    }
                                }
                            });

                            $(this).text(summ_family.toFixed(2));
                        });
                });

                if (!$(this).find(".form-check-input:checked").length) {
                    $(this).closest(".add-g").remove();

                    confirmApdrDisableStatus();
                    selectFamilyMember();
                    //return;
                    //if($(this))
                }
            });
    }

    caclulateSumm();

    function reCaclulateSumm() {
        $(".box-style-1.active").each(function () {
            var id = $(this).data("id");
            var summ = 0;
            var summ_family = 0;
            var summ_2 = 0;
            var summ_family_2 = [];

            $(".box-style-1.active[data-id='" + id + "'] .form-check-input:not(.green)").each(function () {
                let cik = 0;
                if (!$(this).closest(".add-g").length) {
                    cik = $(this).parent().parent().find(".float-end.nosss2").text();

                    cik = cik.replace("+ ", "");

                    if ($(this).is(":checked") && cik) summ += parseFloat(cik);
                } else {
                    cik = $(this).parent().parent().find(".float-end.nosss2").text();

                    cik = cik.replace("+ ", "");

                    if ($(this).is(":checked") && cik) {
                        summ_family += parseFloat(cik);
                    }
                }
            });

            $('.summ[data-id="' + id + '"]').text(summ.toFixed(2));

            if (summ_family > 0) $('.summ_family[data-id="' + id + '"]').text(" + " + summ_family.toFixed(2));
            else $('.summ_family[data-id="' + id + '"]').text("");

            $(".box-style-1.active .form-check-input:not(.green)").each(function () {
                let cik = 0;
                if (!$(this).closest(".add-g").length) {
                    cik = $(this).parent().parent().find(".float-end.nosss2").text();

                    cik = cik.replace("+ ", "");

                    if ($(this).is(":checked") && cik) summ_2 += parseFloat(cik);
                } else {
                    cik = $(this).parent().parent().find(".float-end.nosss2").text();

                    cik = cik.replace("+ ", "");

                    if ($(this).is(":checked") && cik) {
                        var u_id = $(this).parent().parent().find(".select-family-member").val();
                        summ_family_2.push({ family_id: u_id, price: cik });
                    }
                }
            });

            $("table .summ2:not(.family-member)").text(summ_2.toFixed(2));

            $("table.for-family-member").each(function () {
                var self = this;
                var kopsumma = 0;
                summ_family_2.forEach(function (element) {
                    if (element.family_id == $(self).data("family_id")) {
                        kopsumma += parseFloat(element.price);
                    }
                });
                $(this).find(".summ2").text(kopsumma.toFixed(2));

                //ejam cauri visiem apdrosinatajiem
                $(this)
                    .find(".summ")
                    .each(function () {
                        var self2 = this;
                        var id = $(this).data("id");

                        summ_family = 0;
                        $(".box-style-1.active[data-id='" + id + "'] .form-check-input:not(.green)").each(function () {
                            let cik = 0;

                            if ($(this).closest(".add-g").length) {
                                cik = $(this).parent().parent().find(".float-end.nosss2").text();

                                cik = cik.replace("+ ", "");

                                if ($(this).is(":checked") && cik) {
                                    var u_id = $(this).parent().parent().find(".select-family-member").val();
                                    if (u_id == $(self2).closest(".for-family-member").data("family_id")) summ_family += parseFloat(cik);
                                }
                            }
                        });

                        $(this).text(summ_family.toFixed(2));
                    });
            });
        });
    }

    function redzIzmaksass() {
        $(".form-check-input.redz_izmaksas_room_all").on("change", function () {
            var company_id = $(this).closest("td").data("company_id");
            var redz = $(this).is(":checked") ? "1" : "0";

            $.post("?room=redz_izmaksas", { company_id, redz }, function () {});
        });
    }

    redzIzmaksass();

    function insurance_who() {}

    insurance_who();

    function test23() {
        $("body")
            .find(".form-check-input")
            .on("change", function () {
                if ($(this).hasClass("insurance_who")) {
                    var darbinieks_id = $(this).closest("tr").data("id");
                    var apdrosinasana_id = $(this).closest("td").data("id");
                    var company_id = $(this).closest("td").data("company_id");
                    var apmaksat = $(this).is(":checked") ? "1" : "0";

                    //vai šī ir papildprogramm? Ja jā tad jābūt obligāti atķeksētai pamatprogrammai!!!

                    if ($(this).hasClass("ir_papildprogramma") && !$(this).closest("tr").find(".ir_papatmprogramma").is(":checked")) {
                        $(this).removeAttr("checked");
                        $(this).prop("checked", false);
                        $(this).closest(".form-check").removeClass("checked");

                        return false;
                    } else if ($(this).hasClass("ir_papatmprogramma") && $(this).closest("tr").find(".ir_papatmprogramma:checked").length == 2) {
                        $(this).removeAttr("checked");
                        $(this).prop("checked", false);
                        $(this).closest(".form-check").removeClass("checked");

                        return false;
                    } else if ($(this).hasClass("ir_papatmprogramma") && $(this).closest("tr").find(".ir_papildprogramma").is(":checked")) {
                        if (apmaksat == "0") {
                            $(this)
                                .closest("tr")
                                .find(".ir_papildprogramma")
                                .each(function () {
                                    if ($(this).is(":checked")) {
                                        //$(this).trigger("change");

                                        $(this).removeAttr("checked");
                                        $(this).prop("checked", false);
                                        $(this).closest(".form-check").removeClass("checked");

                                        var darbinieks_id2 = $(this).closest("tr").data("id");
                                        var apdrosinasana_id2 = $(this).closest("td").data("id");
                                        var company_id2 = $(this).closest("td").data("company_id");
                                        var apmaksat2 = "0";

                                        $.post(
                                            "?room=insurance_who", {
                                                darbinieks_id: darbinieks_id2,
                                                apdrosinasana_id: apdrosinasana_id2,
                                                company_id: company_id2,
                                                apmaksat: apmaksat2,
                                            },
                                            function () {}
                                        );
                                    }
                                });

                            //return false;
                        }
                    }

                    $.post("?room=insurance_who", { darbinieks_id, apdrosinasana_id, company_id, apmaksat }, function () {});
                } else if ($(this).hasClass("redz_izmaksas_room")) {
                    var darbinieks_id = $(this).closest("tr").data("id");
                    var company_id = $(this).closest("td").data("company_id");
                    var redz = $(this).is(":checked") ? "1" : "0";

                    $.post("?room=redz_izmaksas", { darbinieks_id, company_id, redz }, function () {});
                }
            });
    }
    test23();

    var sis_jauta_var = false;

    $(".form-check-input.insurance_who_all")
        .unbind("change")
        .on("change", function (e) {
            if (!sis_jauta_var) {
                return false;
            }

            var apdrosinasana_id = $(this).closest("td").data("id");
            var company_id = $(this).closest("td").data("company_id");
            var apmaksat = $(this).is(":checked") ? "1" : "0";

            $.post("?room=insurance_who", { apdrosinasana_id, company_id, apmaksat }, function () {});
        });

    function confirmApdrDisableStatus() {
        //vai visiem kuriem checked ir aipiditi visi lauki?
        var viss_aizpildits = true;
        var ir_vienads_pk = true;

        $(".box-style-1.active").each(function () {
            var bboxxx = this;

            $(bboxxx)
                .find(".add-g .form-check-input:checked")
                .each(function () {
                    $(this)
                        .closest(".add-g")
                        .find("input[type='text']")
                        .each(function () {
                            if (!$(this).val()) {
                                viss_aizpildits = false;
                            }
                        });
                    $(this)
                        .closest(".add-g")
                        .find("select")
                        .each(function () {
                            if (!$(this).val()) {
                                viss_aizpildits = false;
                            }
                        });
                });

            //ja kads ir pie papildprogrammas - tad tadam pasam Personas Kodam jabut pie Pamata programmas

            //ejam cauri visiem kuri nav pamata un skatamies vai tada pats id ir arī ar pamatu - ja nav tad nevaram apstiprināt pasūtījumu!!!

            $(bboxxx)
                .find(".nosss.question-apdrosinasana-show[data-is_main_programm='0'], .nosss2.question-apdrosinasana-show[data-is_main_programm='0']")
                .parent()
                .find(".add-g")
                .each(function () {
                    //console.log("NAV PAMATA!!!");
                    //vai vinam ir pamata programmas?
                    var this_fam_id = $(this).find(".select-family-member").val();
                    console.log("meklejam kur fam_id " + this_fam_id);
                    if (!$(bboxxx).find(".ap[data-is_main_programm='1'] .select-family-member option[value='" + this_fam_id + "']:selected").length) {
                        if ($(bboxxx).data("apdr_tips") == "veselibas-apdrosinasana") {
                            ir_vienads_pk = false;
                        }
                    }
                });
        });

        if (!viss_aizpildits) {
            $(".apstiprinat-apdrsinasanas").attr("disabled", "disabled");
            $(".apstiprinat-apdrsinasanas").prop("disabled", true);
        } else if (!ir_vienads_pk) {
            $(".apstiprinat-apdrsinasanas").attr("disabled", "disabled");
            $(".apstiprinat-apdrsinasanas").prop("disabled", true);
        } else {
            $(".apstiprinat-apdrsinasanas").attr("disabled", "");
            $(".apstiprinat-apdrsinasanas").prop("disabled", false);
        }
    }

    $(".vvv").on("click", function () {
        if ($(this).hasClass("vvv-dd")) {
            $("#vvv-dd").show();
            $("#vvv-dn").hide();
            $(".vvv").removeClass("d-block").hide();
        } else {
            $("#vvv-dn").show();
            $("#vvv-dd").hide();
            $(".vvv").removeClass("d-block").hide();
        }
    });

    $("#menu-opener").on("click", function () {
        $(this).toggleClass("active");
        $("#menu-mobile").toggleClass("active");
        $("header").toggleClass("active");
    });

    $("#menu-mobile ul li").on("click", function () {
        $("#menu-mobile .clicked").not(this).removeClass("clicked");
        $(this).toggleClass("clicked");
    });

    $(".onclick-hide").on("click", function () {
        $(this).closest(".notification-box").parent().prev().fadeOut();
        $(this).closest(".notification-box").fadeOut();
    });

    function popupAllHide() {
        $(".popup_all-hide")
            .off()
            .on("click", function (e) {
                e.preventDefault();
                $("#popup_all").fadeOut().removeClass("active");
            });
    }

    $(".edit-user").on("click", function (e) {
        e.preventDefault();
        $("#popup_all").css("display", "flex").hide().fadeIn();

        var darbinieks_id = $(this).closest("tr").data("id");

        $.post("room/edit_user.php", { darbinieks_id }, function (data) {
            $("#popup_all").find(".popup_all-box").html(data);
            popupAllHide();
        });
    });

    $(".add-darbinieks-hide").on("click", function (e) {
        e.preventDefault();
        $("#add-darbinieks").fadeOut().removeClass("active");
    });

    $(".add-darbinieks").on("click", function (e) {
        e.preventDefault();
        $("#add-darbinieks").css("display", "flex").hide().fadeIn();
    });

    $(".question-apdrosinasana-show").on("click", function (e) {
        e.preventDefault();

        var main_id = $(this).data("main-id");

        $(".question-apdrosinasana#apdrosinasana-" + main_id)
            .css("display", "flex")
            .hide()
            .fadeIn();

        var div = $(".question-apdrosinasana-box");
        div.scrollTop(0);

        // alert(main_id);
        /*console.log(
            $(".question-apdrosinasana#apdrosinasana-" + main_id)
                .find(".scroll-" + $(this).data("id"))
                .position().top
        );*/
        var temp_top = $(".question-apdrosinasana#apdrosinasana-" + main_id)
            .find(".scroll-" + $(this).data("id"))
            .position().top;

        window.location.hash = $(this).data("id");

        if ($(this).data("id") > 0) {
            setTimeout(function () {
                div.animate({ scrollTop: temp_top - 15 }, 500, "swing", function () {
                    //alert("Finished animating");
                });
            }, 100);
        }
    });

    //hide popup if back history
    $(window).on("popstate", function () {
        if (window.location.hash == "") {
            $(".question-apdrosinasana").fadeOut().removeClass("active");
        } else {
            /*
            //$("#question-apdrosinasana").css("display", "flex").show();

            var hashX = window.location.hash;

            hashX = hashX.replace("#", "");

            var div = $(".question-apdrosinasana-box");
            //div.scrollTop(0);

            var temp_top = $("#scroll-"+hashX).position().top + div.scrollTop();

            if(hashX > 0) {
                setTimeout(function(){
                    div.animate({scrollTop:temp_top-15}, 500, 'swing', function() {
                        //alert("Finished animating");
                    });
                }, 100)
            }
            */
        }
    });

    $(".question-apdrosinasana-hide").on("click", function (e) {
        e.preventDefault();
        $(".question-apdrosinasana").fadeOut().removeClass("active");
    });

    $(".piesakos").on("click", function (e) {
        e.preventDefault();
        $(".question-apdrosinasana").fadeOut().removeClass("active");

        //console.log($(".question-apdrosinasana-show[data-main-id='"+$(this).closest(".question-apdrosinasana").data("main-id")+"'][data-id='"+$(this).data("id")+"']").length)

        $(
            ".question-apdrosinasana-show[data-main-id='" +
            $(this).closest(".question-apdrosinasana").data("main-id") +
            "'][data-id='" +
            $(this).data("id") +
            "']:not(.question)"
        )
            .parent()
            .find(".form-check-input:not(:disabled)")
            .prop("checked", true)
            .parent()
            .addClass("checked");

        reCaclulateSumm();
    });

    function checkboxSwicherClick() {
        $(".checkbox-swicher")
            .off()
            .on("click", function () {
                $(this).parent().find(".form-check-input")[0].click();
            });
    }

    checkboxSwicherClick();

    function menesaMaksa(cena, cikMaksajumi) {
        // Calculate the individual part value
        var partValue = (Math.floor((cena / cikMaksajumi) * 100) / 100).toFixed(2); // Ensure no more than 2 decimal places

        // Calculate the remaining amount
        var remainingAmount = (cena - partValue * cikMaksajumi).toFixed(2); // Ensure no more than 2 decimal places

        // Create an array of parts
        var parts = new Array(cikMaksajumi).fill(Number(partValue));

        // Distribute the remaining amount
        var remainingAmountInCents = remainingAmount * 100;
        for (var i = 0; i < remainingAmountInCents; i++) {
            parts[i % cikMaksajumi] = (Number(parts[i % cikMaksajumi]) + 0.01).toFixed(2);
        }

        // Output the array of parts
        return parts;
    }

    $('.box-style-1 select[name="apmaksas-sadalijums"]').on("change", function (e) {
        var self = this;

        $(this)
            .closest(".box-style-1")
            .find("div.nosss2:not(.question-apdrosinasana-show)")
            .each(function () {
                var cena = parseFloat($(this).data("cena"));
                var cikMaksajumi = parseInt($(self).val());

                var pirmaMenesaMaksa = 0;
                if ($(this).closest(".add-g").length) {
                    pirmaMenesaMaksa = parseFloat(cena).toFixed(2);
                } else {
                    pirmaMenesaMaksa = parseFloat(menesaMaksa(cena, cikMaksajumi)[0]).toFixed(2);
                }

                $(this).text(pirmaMenesaMaksa);

                //parekinat summas
                reCaclulateSumm();
            });
    });

    $(".add-family-member").on("click", function () {
        $("#add-family-member").css("display", "flex").hide().fadeIn();
    });

    $("#add-family-member form").on("submit", function (e) {
        //e.preventDefault();
        //return;
    });

    $(".add-family-member-hide").on("click", function (e) {
        $("#add-family-member").fadeOut().removeClass("active");
    });

    $(".popup-success-box .submit").on("click", function () {
        //$("#popup-success").fadeOut().removeClass("active");
        //$("#popup-success").closest(".popup-success-box").find("> *").remove().append("<h1>LOADING</h1>");
        $("#popup-success .popup-success-box").find("> *").remove();
        $("#popup-success .popup-success-box").append("<h1>LOADING</h1>");

        //alert(parseFloat($(".summ2").text()));

        var apdrosinasanas = [];

        $(".box-style-1:not(.confirmed)")
            .find(".nosss2")
            .parent()
            .find(".form-check-input")
            .each(function () {
                var apdr_id = $(this).parent().parent().find(".nosss2").data("apdrosinasana_id");
                var is_checked = $(this).is(":checked") ? "1" : "0";
                var apmaksas_sadalijums = $(this).closest(".box-style-1").find('[name="apmaksas-sadalijums"]').val();
                //var gimenes_loceklis = $(this).closest(".add-g").length ? "1" : "0";
                var family_id = $(this).closest(".add-g").find("select.select-family-member").val();

                apdrosinasanas.push({ apdr_id: apdr_id, is_checked: is_checked, apmaksas_sadalijums: apmaksas_sadalijums, family_id: family_id });
            });

        if (parseFloat($(".summ2:not(.family-member)").text()) > 0) {
            //$("#popup-pay").css("display", "flex").hide().fadeIn();
            $(".veiciet-apmaksu-txt").show();
            $(".apstiprinat-apdrsinasanas").hide();
            $(".ampaksat-apdrsinasanas").show();
        }

        $(".select-family-member").attr("disabled", "disabled");
        $(".select-family-member").prop("disabled", true);

        $(".form-check-input, .add-family, [name='apmaksas-sadalijums']").attr("disabled", "disabled");
        $(".form-check-input, .add-family, [name='apmaksas-sadalijums']").prop("disabled", true);
        $(".piesakos").parent().remove();

        $.post("room/darba_nemejs_conformed.php", { apdrosinasanas }, function () {
            location.reload();
        });
    });

    $(".popup-success-hide").on("click", function (e) {
        e.preventDefault();
        $("#popup-success").fadeOut().removeClass("active");
    });

    $(".apstiprinat-apdrsinasanas").on("click", function (e) {
        $("#popup-success").css("display", "flex").hide().fadeIn();
    });

    function isUrlValid(url) {
        return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(
            url
        );
    }

    $(".popup-pay-box .submit").on("click", function () {
        $("#popup-pay").fadeOut().removeClass("active");
        //var kevinURL = "";
        $.post("room/kevin.php", { ajax: 1 }, function (kevinURL) {
            if (isUrlValid(kevinURL)) {
                window.location.href = kevinURL;
            } else {
                // location.reload();
            }
        });
    });

    $(".popup-pay-hide").on("click", function (e) {
        e.preventDefault();
        $("#popup-pay").fadeOut().removeClass("active");
    });

    $(".confirm-send-notifications").on("click", function (e) {
        e.preventDefault();

        var self = this;
        var tips_id = $("#confirm-send-notifications").data("tips_id");
        var company_id = $("#confirm-send-notifications").data("company_id");

        $.post("?room=confirm_send_notifications", { tips_id, company_id }, function (data) {
            $("#confirm-send-notifications").find("span").html(data);
        });

        $("#confirm-send-notifications").css("display", "flex").hide().fadeIn();
    });
    $(".confirm-send-notifications-box .submit").on("click", function () {
        $("#confirm-send-notifications").fadeOut().removeClass("active");
        var tips_id = $("#confirm-send-notifications").data("tips_id");
        var company_id = $("#confirm-send-notifications").data("company_id");

        $.post("?room=confirm_send_notifications", { tips_id, company_id, pievienot: "1" }, function () {
            //$("#confirm-send-notifications").find("span").html(data);
            location.reload();
        });
    });
    $(".confirm-send-notifications-hide").on("click", function (e) {
        e.preventDefault();
        $("#confirm-send-notifications").fadeOut().removeClass("active");
    });

    var jautat_vai_atzimet_visus = true;

    $(".atzimet-visus-box .submit").on("click", function () {
        jautat_vai_atzimet_visus = false;
        sis_jauta_var = true;
        $(".sis_jauta")[0].click();
        sis_jauta_var = false;
        $("#atzimet-visus").fadeOut().removeClass("active");
    });

    $(".atzimet-visus-hide").on("click", function (e) {
        e.preventDefault();
        $("#atzimet-visus").fadeOut().removeClass("active");
        jautat_vai_atzimet_visus = true;
        $(".sis_jauta").removeClass("sis_jauta");
    });

    $(".form-check-input").on("change", function (e) {

        if ($(this).hasClass("sis_jauta") && jautat_vai_atzimet_visus) {
            return;
        }

        if ($(this).closest("tr").hasClass("atzimet-visus")) {
            $(this).addClass("sis_jauta");

            if (jautat_vai_atzimet_visus) {
                $("#atzimet-visus").css("display", "flex").hide().fadeIn();
                $(this)[0].click();
                //e.preventDefault();
                return;
            }

            jautat_vai_atzimet_visus = true;

            var temp_index = 1;
            var count_index = true;

            $(".sis_jauta")
                .closest("tr")
                .find("td")
                .each(function () {
                    if ($(this).find(".sis_jauta").length) {
                        count_index = false;
                    }
                    if (count_index) {
                        if ($(this).hasAttr("colspan")) {
                            temp_index = temp_index + parseInt($(this).attr("colspan"));
                        } else {
                            temp_index++;
                        }
                    }
                });

            var elementCheckAll = $(".sis_jauta");

            var kada_programma_jauta = "";

            if ($(".sis_jauta").hasClass("ir_papatmprogramma")) {
                kada_programma_jauta = "ir_papatmprogramma";
            } else if ($(".sis_jauta").hasClass("ir_papildprogramma")) {
                kada_programma_jauta = "ir_papildprogramma";
            }

            $(".sis_jauta").removeClass("sis_jauta");

            var temp_checked = false;

            if ($(this).is(":checked")) {
                temp_checked = true;
            } else {
                temp_checked = false;
            }

            //var temp_index = $(this).closest("td").index() + 2;

            //$(this).closest("table").find("tr td:nth-child(6) .form-check-input input").prop("checked", true);
            $(this)
                .closest("table")
                .find("tr td:nth-child(" + temp_index + ")")
                .each(function () {
                    if ($(this).closest("tr").hasClass("atzimet-visus")) {
                        return;
                    }

                    if ($(this).find(".form-check-input").is(":disabled")) {
                        return;
                    }

                    if (
                        !$(this).find("input").is(":checked") &&
                        $(this).find("input").hasClass("ir_papatmprogramma") &&
                        $(this).closest("tr").find(".ir_papatmprogramma:checked").length == 1
                    ) {
                        $(this).closest("tr").find(".ir_papatmprogramma:checked").removeAttr("checked");
                        $(this).closest("tr").find(".ir_papatmprogramma:checked").prop("checked", false);
                        $(this).closest("tr").find(".ir_papatmprogramma:checked").closest(".form-check").removeClass("checked");

                        $(".ir_papatmprogramma.insurance_who_all").not($(elementCheckAll)).removeAttr("checked");
                        $(".ir_papatmprogramma.insurance_who_all").not($(elementCheckAll)).prop("checked", false);
                        $(".ir_papatmprogramma.insurance_who_all").not($(elementCheckAll)).closest(".form-check").removeClass("checked");
                        //insurance_who_all
                        //return;
                    }

                    if (temp_checked) {
                        if (kada_programma_jauta == "ir_papildprogramma") {
                            // ja
                            if ($(this).closest("tr").find(".ir_papatmprogramma").is(":checked")) {
                                $(this).find(".form-check-input").attr("checked", "checked");
                                $(this).find(".form-check-input").prop("checked", true);
                                $(this).find(".form-check").addClass("checked");
                            }
                        } else {
                            $(this).find(".form-check-input").attr("checked", "checked");
                            $(this).find(".form-check-input").prop("checked", true);
                            $(this).find(".form-check").addClass("checked");
                        }
                    } else {
                        if (kada_programma_jauta == "ir_papatmprogramma") {
                            if ($(this).closest("tr").find(".ir_papildprogramma").is(":checked")) {
                                $(this)
                                    .closest("tr")
                                    .find(".ir_papildprogramma")
                                    .each(function () {
                                        if ($(this).is(":checked")) {
                                            //$(this).trigger("change");

                                            $(this).removeAttr("checked");
                                            $(this).prop("checked", false);
                                            $(this).closest(".form-check").removeClass("checked");
                                        }
                                    });
                            }
                        } else if (kada_programma_jauta == "ir_papildprogramma") {
                        }

                        $(this).find(".form-check-input").removeAttr("checked");
                        $(this).find(".form-check-input").prop("checked", false);
                        $(this).find(".form-check").removeClass("checked");
                    }
                });

            //$(this).find(".form-check-input")[0].click();
        }
    });

    function tdClick() {
        $("body")
            .find("td")
            .on("click", function (e) {
                if ($(e.target).hasClass("form-check-input") || !$(this).find(".form-check-input").length) return;

                if ($(this).closest("tr").hasClass("atzimet-visus")) {
                    if (jautat_vai_atzimet_visus) {
                        $("#atzimet-visus").css("display", "flex").hide().fadeIn();
                        //$(this).find(".form-check-input")[0].click();
                        $(this).find(".form-check-input").addClass("sis_jauta");
                        return;
                    }
                } else {
                    $(this).find(".form-check-input")[0].click();
                }
            });
    }
    tdClick();

    $("[name='pievienosanas-metode']").on("change", function () {
        $(".pievienosanas-metode").hide();
        $("#" + $(this).val()).show();
    });

    $(".sapratu").on("click", function (e) {
        e.preventDefault();
        $("#error").fadeOut().removeClass("active");
        $("#success").fadeOut().removeClass("active");
    });

    function dzestDarb() {
        $(".dzest").hover(
            function () {
                $(this).closest("tr").addClass("del");
            },
            function () {
                $(this).closest("tr").removeClass("del");
            }
        );

        $(".dzest").on("click", function (e) {
            e.preventDefault();

            $(".dalete-user-body").html("Loading...");

            $('[name="send-time"]').val("").change();

            var darbinieks_id = $(this).closest("tr").data("id");

            $("#delete-darbinieks").css("display", "flex").hide().fadeIn();
            $('[name="darbinieks_id"]').val($(this).closest("tr").data("id"));

            $.post($(this).data("url")+"/?room=deleteUserHtml", { darbinieks_id }, function (data) {
                $(".dalete-user-body").html(data);
                checkboxSwicherClick();
                asdf();

                $(".dalete-user-body")
                    .find(".datepicker")
                    .each(function () {
                        $(this).datepicker({
                            // showButtonPanel: true
                            dateFormat: "dd.mm.yy",
                            firstDay: 1,
                        });
                    });
            });

            $("#dzest-vards").text($(this).data("dzest-vards"));
            var self = this;

            setTimeout(function () {
                $(self).closest("tr").addClass("del");
            }, 1);
        });
    }

    dzestDarb();

    $(".delete-darbinieks-hide").on("click", function (e) {
        e.preventDefault();
        $("#delete-darbinieks").fadeOut().removeClass("active");
        $(".del").removeClass("del");
    });

    $(".datepicker").each(function () {
        // $(this).datepicker({
        //     // showButtonPanel: true
        //     dateFormat: "dd.mm.yy",
        //     firstDay: 1,
        // });
    });

    $("input.datepicker-no").on("change", function () {
        var currentUrl = $(this).closest(".uuu").find(".jjj").attr("href");
        var url = new URL(currentUrl);
        url.searchParams.set("no", $(this).val()); // setting your param
        var newUrl = url.href;
        $(this).closest(".uuu").find(".jjj").attr("href", newUrl);
    });

    $("input.datepicker-lidz").on("change", function () {
        var currentUrl = $(this).closest(".uuu").find(".jjj").attr("href");
        var url = new URL(currentUrl);
        url.searchParams.set("lidz", $(this).val()); // setting your param
        var newUrl = url.href;
        $(this).closest(".uuu").find(".jjj").attr("href", newUrl);
    });

    function asdf() {
        $("[data-asdf] input, [data-asdf2] input")
            .off()
            .on("change", function () {
                //$(this).parent().parent().find(".datepicker").toggle();
                if ($(this).closest("[data-asdf]").length) {
                    if (!$(this).is(":checked")) {
                        // var asdf = $(this).parent().data("asdf");
                        // $('[data-asdf2="' + asdf + '"] .form-check-input').attr("checked", "checked");
                        // $('[data-asdf2="' + asdf + '"] .form-check-input').prop("checked", true);
                    } else {
                        var asdf = $(this).parent().data("asdf");
                        $('[data-asdf2="' + asdf + '"] .form-check-input').attr("checked", "");
                        $('[data-asdf2="' + asdf + '"] .form-check-input').prop("checked", false);
                    }
                } else if ($(this).closest("[data-asdf2]").length) {
                    if (!$(this).is(":checked")) {
                        // var asdf = $(this).closest("[data-asdf2]").data("asdf2");
                        //  $('[data-asdf="' + asdf + '"] .form-check-input').attr("checked", "checked");
                        //  $('[data-asdf="' + asdf + '"] .form-check-input').prop("checked", true);
                    } else {
                        var asdf = $(this).closest("[data-asdf2]").data("asdf2");
                        $('[data-asdf="' + asdf + '"] .form-check-input').attr("checked", "");
                        $('[data-asdf="' + asdf + '"] .form-check-input').prop("checked", false);
                    }
                }
            });
    }

    /********/

    function showHidePaymentTable() {
        var showFamilyMembers = [];
        $(".select-family-member").each(function () {
            if ($(this).val()) {
                showFamilyMembers.push($(this).val());
            }
        });

        $(".payment-table.for-family-member").hide();

        showFamilyMembers.forEach((element) => {
            $(".payment-table.for-family-member[data-family_id='" + element + "']").show();
        });
    }

    function selectFamilyMember() {
        showHidePaymentTable();

        $(".select-family-member")
            .unbind("change")
            .on("change", function () {
                if ($(this).closest('[data-is_main_programm="1"]').length) {
                    $(this).addClass("temp_class");
                    let temp_fam_id = $(this).val();
                    if (
                        $(".box-style-1.active").find(
                            ".ap[data-is_main_programm='1'] .select-family-member:not(.temp_class) option[value='" + temp_fam_id + "']:selected"
                        ).length == 1
                    ) {
                        $(".box-style-1.active")
                            .find(
                                ".ap[data-is_main_programm='1'] .select-family-member:not(.temp_class) option[value='" + temp_fam_id + "']:selected"
                            )
                            .closest(".add-g")
                            .find("input")[0]
                            .click();
                    }
                    $(this).removeClass("temp_class");
                }
                showHidePaymentTable();

                confirmApdrDisableStatus();

                reCaclulateSumm();
            });
    }




    $(".dn_mustbuy_if_family_add > .form-check input ").on("click", function () {
        if (!$(this).is(":checked")) {
            //alert("a");
            $(this).closest(".dn_mustbuy_if_family_add").find(".add-g").remove();
        }
    });

    $(".add-family").on("click", function () {
        var self = this;

        var cena_gimenes_loceklis_full = $(this).data("cena_gimenes_loceklis");
        var apdrosinasana_tips_id = $(this).data("apdrosinasana_tips_id");
        //cena_gimenes_loceklis = menesaMaksa(cena_gimenes_loceklis, cikMaksajumi)[0];

        $(".apstiprinat-apdrsinasanas").attr("disabled", "disabled");
        $(".apstiprinat-apdrsinasanas").prop("disabled", true);

        var apdr_id = $(this).parent().find(".nosss2.question-apdrosinasana-show").data("apdrosinasana_id");
        if (!apdr_id) {
            apdr_id = $(this).parent().find(".nosss.question-apdrosinasana-show").data("apdrosinasana_id");
        }

        if ($(this).closest(".dn_mustbuy_if_family_add").length) {
            if ($(this).closest(".dn_mustbuy_if_family_add").find(">.form-check input:not(:checked)").length)
                $(this).closest(".dn_mustbuy_if_family_add").find(">.form-check input:not(:checked)")[0].click();
            //alert("dn_mustbuy_if_family_add");
        }

        $.post("room/add_family_elemets.php", { cena_gimenes_loceklis_full, apdr_id, apdrosinasana_tips_id }, function (html) {
            if (html == "no_family_added_yet") {
                $("#add-family-member").css("display", "flex").hide().fadeIn();
            } else {
                $(html).insertBefore($(self));
            }
            caclulateSumm();
            reCaclulateSumm();
            selectFamilyMember();
            $(".select-family-member").on("change", function () {
                if ($(this).find(":selected").hasClass("add-family-member")) {
                    $("#add-family-member").css("display", "flex").hide().fadeIn();
                    $(this).closest(".add-g").remove();
                }
            });
        });

        /*$(`
        <div class="row pb-2 add-g">
            <span>Informācija par ģimenes locekli:</span>
            <div class="form-check form-switch float-start">
                <input class="form-check-input" type="checkbox" checked>
            </div>
            <div class="col-12 mb-2">
                <input type="text" placeholder="Vārds" class="form-control xvards"/>
            </div>
            <div class="col-12 mb-2">
                <input type="text" placeholder="Uzvārds" class="form-control xuzvards"/>
            </div>
            <div class="col-12 mb-2">
                <input type="text" placeholder="Personas-kods" class="form-control xpersonaskods"/>
            </div>
            <div class="col-12 mb-2">
                <input type="text" placeholder="Dzimsanas datums" class="form-control xdzimsanasdatums"/>
            </div>
            <div class="float-end nosss2 text-end" data-cena="${cena_gimenes_loceklis_full}" data-apdrosinasana_id="${apdr_id}">+ ${cena_gimenes_loceklis_full}</div>
        </div>`).insertBefore($(this));*/
    });



    /****PARTAISIT******/
    let maxFileSize = 10 * 1024 * 1024; // 10MB
    let allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain'];

    $('#fileUploadForm').submit(function (e) {
        e.preventDefault(); // Stop the form from submitting normally

        let user_email = $('#fileUploadForm input[name="user_email"]').val();
        let sum = $('#fileUploadForm input[name="sum"]').val();
        let bankAccountNumber = $('#fileUploadForm input[name="bank_account_number"]').val();
        let category = $('#fileUploadForm input[name="category"]').val();
        //let files = $('#fileUploadForm input[name="uploadedFiles[]"]')[0].files;


        let errorMessage = '';

        // Validate email
        if (!validateEmail(user_email)) {
            errorMessage = "Invalid email address.";
        }

        // Check if files are added
        if (filesArray.length === 0) {
            errorMessage = "Please add file or files to submit the form.";
        } else {
            // Validate files
            let hasErrors = false; //
            filesArray.forEach(fileObj => {
                const file = fileObj.file; // Access the actual file object

                if (file.size > maxFileSize) {
                    errorMessage = `${file.name} exceeds the 10MB size limit.`;
                    hasErrors = true;
                } else if (!allowedTypes.includes(file.type)) {
                    errorMessage = `${file.name} type not allowed.`;
                    hasErrors = true;
                }
            });

            // Additional validations for other fields
            if (!sum || !bankAccountNumber || !category) {
                errorMessage = "Please fill in all required fields.";
                hasErrors = true; // Mark that there's an error
            }
        }

        if (errorMessage) {
            $('#errorMessage').text(errorMessage); // Display error message
            return; // Stop form submission if there's an error
        }

        // Use FormData to send files with AJAX if there are no errors
        let formData = new FormData(this);

        // Append each file in filesArray to formData
        filesArray.forEach(fileObj => {
            formData.append('attached_files[]', fileObj.file); // Add each file with the name 'attached_files[]'
        });


        $.ajax({
            url: '?room=atverta_polise_form', // Your PHP file for handling uploads
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json', // Expect JSON response from the server
            success: function (response) {
                if (response.status === 'error') {
                    $('#errorMessage').html(response.message); // Display error messages from PHP
                } else {
                    location.reload();
                    $('#errorMessage').html(`<span style="color: green;">${response.message}</span>`); // Show success message
                }
            },
            error: function () {
                $('#errorMessage').text("An error occurred while uploading files. Please try again.");
            }
        });
    });


    $('#fileUploadForm2').submit(function (e) {
        e.preventDefault(); // Stop the form from submitting normally

        // Determine which button was clicked
        let submitButton = $(document.activeElement).attr('name');

        // Variables for email inputs and error message display
        let responder_email1 = $('#fileUploadForm2 input[name="responder_email1"]').val();
        let responder_email2 = $('#fileUploadForm2 input[name="responder_email2"]').val();
        let errorMessage = '';

        // If "accept" is clicked, email and email2 are required
        if (submitButton === 'accept') {
            if (!validateEmail(responder_email1)) {
                errorMessage = "Valid email address is required.";
            }
            if (responder_email1 == "") {
                errorMessage = "Email address is required.";
            }
            if (responder_email2 != "") {
                if (!validateEmail(responder_email2)) {
                    errorMessage = "Valid email address is required.";
                }
            }
        } else {
            if (responder_email1 != "") {
                if (!validateEmail(responder_email1)) {
                    errorMessage = "Valid email address is required.";
                }
            }
            if (responder_email2 != "") {
                if (!validateEmail(responder_email2)) {
                    errorMessage = "Valid email address is required.";
                }
            }
        }

        // Show error message if there is one
        if (errorMessage) {
            $('#errorMessage2').text(errorMessage);
            return; // Stop form submission if there's an error
        }

        // Proceed with AJAX submission if no errors
        let formData = new FormData(this);
        let status = submitButton === 'decline' ? 0 : 2; // 0 for decline, 2 for accept
        formData.append('status', status); // Append status to FormData

        $.ajax({
            url: '?room=atverta_polise_confirm_form', // Your PHP handler for form submission
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json', // Expect JSON response from the server
            success: function (response) {
                if (response.status === 'error') {
                    $('#errorMessage2').html(response.message);
                } else {
                    location.reload();
                    $('#errorMessage2').html(`<span style="color: green;">${response.message}</span>`);
                }
            },
            error: function () {
                $('#errorMessage2').text("An error occurred. Please try again.");
            }
        });
    });

    $('#formResponder').submit(function (e) {
        e.preventDefault(); // Stop the form from submitting normally

        let submitButton = $(document.activeElement).attr('name');

        let formData = new FormData(this);
        let status = submitButton === 'decline' ? 0 : 2; // 0 for decline, 2 for accept
        formData.append('status', status); // Append status to FormData

        //empty file input
        $('#fileUploadForm input[name="uploadedFiles[]"]').val('');

        // Append each file in filesArray to formData
        filesArray.forEach(fileObj => {
            formData.append('uploadedFiles[]', fileObj.file); // Add each file with the name 'attached_files[]'
        });

        $.ajax({
            url: '?room=atverta_polise_responder_confirm_form', // Your PHP handler for form submission
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json', // Expect JSON response from the server
            success: function (response) {
                if (response.status === 'error') {
                    $('#errorMessage2').html(response.message);
                } else {
                    window.location.href = "/";
                    $('#errorMessage2').html(`<span style="color: green;">${response.message}</span>`);
                }
            },
            error: function () {
                $('#errorMessage2').text("An error occurred. Please try again.");
            }
        });

    });

    $('#fileUploadFormNN').submit(function (e) {
        e.preventDefault(); // Stop the form from submitting normally

        let user_email = $('#fileUploadFormNN input[name="user_email"]').val();
        let sum = $('#fileUploadFormNN input[name="sum"]').val();
        let bankAccountNumber = $('#fileUploadFormNN input[name="bank_account_number"]').val();
        let category = $('#fileUploadFormNN input[name="category"]').val();
        //let files = $('#fileUploadForm input[name="uploadedFiles[]"]')[0].files;

        let errorMessage = '';

        // Validate email
        if (!validateEmail(user_email)) {
            errorMessage = "Invalid email address.";
        }

        // Check if files are added
        if (filesArray.length === 0) {
            errorMessage = "Please add file or files to submit the form.";
        } else {
            // Validate files
            let hasErrors = false; //
            filesArray.forEach(fileObj => {
                const file = fileObj.file; // Access the actual file object

                if (file.size > maxFileSize) {
                    errorMessage = `${file.name} exceeds the 10MB size limit.`;
                    hasErrors = true;
                } else if (!allowedTypes.includes(file.type)) {
                    errorMessage = `${file.name} type not allowed.`;
                    hasErrors = true;
                }
            });

            // Additional validations for other fields
            if (!sum || !bankAccountNumber || !category) {
                errorMessage = "Please fill in all required fields.";
                hasErrors = true; // Mark that there's an error
            }
        }

        if (errorMessage) {
            $('#errorMessage').text(errorMessage); // Display error message
            return; // Stop form submission if there's an error
        }

        // Use FormData to send files with AJAX if there are no errors
        let formData = new FormData(this);

        // Append each file in filesArray to formData
        filesArray.forEach(fileObj => {
            formData.append('attached_files[]', fileObj.file); // Add each file with the name 'attached_files[]'
        });


        $.ajax({
            url: '?room=brivais_limits_form', // Your PHP file for handling uploads
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json', // Expect JSON response from the server
            success: function (response) {
                if (response.status === 'error') {
                    $('#errorMessage').html(response.message); // Display error messages from PHP
                } else {
                    location.reload();
                    $('#errorMessage').html(`<span style="color: green;">${response.message}</span>`); // Show success message
                }
            },
            error: function () {
                $('#errorMessage').text("An error occurred while uploading files. Please try again.");
            }
        });
    });

    $('#fileUploadForm2NN').submit(function (e) {
        e.preventDefault(); // Stop the form from submitting normally

        // Determine which button was clicked
        let submitButton = $(document.activeElement).attr('name');

        // Variables for email inputs and error message display
        let errorMessage = '';


        // Show error message if there is one
        if (errorMessage) {
            $('#errorMessage2').text(errorMessage);
            return; // Stop form submission if there's an error
        }

        // Proceed with AJAX submission if no errors
        let formData = new FormData(this);
        let status = submitButton === 'decline' ? 0 : 2; // 0 for decline, 2 for accept
        formData.append('status', status); // Append status to FormData

        $.ajax({
            url: '?room=brivais_limits_confirm_form', // Your PHP handler for form submission
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json', // Expect JSON response from the server
            success: function (response) {
                if (response.status === 'error') {
                    $('#errorMessage2').html(response.message);
                } else {
                    location.reload();
                    $('#errorMessage2').html(`<span style="color: green;">${response.message}</span>`);
                }
            },
            error: function () {
                $('#errorMessage2').text("An error occurred. Please try again.");
            }
        });
    });



    // Function to validate email
    function validateEmail(email) {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(email);
    }

    $('#uploadedFiles').on('change', function () {
        const fileList = $('#file-list');
        //fileList.empty(); // Clear previous file list

        // Clear filesArray to handle new uploads


        $.each(this.files, function (index, file) {
            const fileId = file.name + file.size;

            if (file.size > maxFileSize) {
                alert(`${file.name} exceeds the 10MB size limit.`);
                return;
            } else if (!allowedTypes.includes(file.type)) {
                alert(`${file.name} type not allowed.`);
                return;
            }

            if (!filesArray.some(fileObj => fileObj.fileId === fileId)) {
                filesArray.push({ file: file, fileId: fileId });
            } else {
                return;
            }

            // Create a new div for each file
            const fileDiv = $('<div>', {
                class: 'btn btn-sm btn-info',
                css: {
                    padding: '3px 25px 3px 15px',
                    height: '23px',
                    lineHeight: '16px',
                    fontSize: '11px',
                    background: '#ffffff',
                    marginRight: '5px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    position: 'relative'
                }
            });

            // Add file name text
            fileDiv.text(file.name);

            // Create a remove button
            const removeButton = $('<span>', {
                class: 'remove-file',
                text: 'x',
                css: {
                    cursor: 'pointer',
                    marginLeft: '5px',
                    color: 'red',
                    position: 'absolute',
                    right: '8px'
                },
                data: { id: fileId }
            });

            // Append remove button to file div
            fileDiv.append(removeButton);
            fileList.append(fileDiv); // Append each file div to the file list
        });
    });

    // Remove file from the list and filesArray
    $('#file-list').on('click', '.remove-file', function () {
        const fileId = $(this).data('id');

        // Remove the file from filesArray
        filesArray = filesArray.filter(fileObj => fileObj.fileId !== fileId);

        // Remove the file div from the display
        $(this).parent().remove();
    });



    $(".btn-test-confirm").click(function (e) {

        var emptyInputs = $(this).closest("form").find('[required]').filter(function () {
            if ($(this).is(':checkbox') || $(this).is(':radio')) {
                return !$('[name="' + $(this).attr('name') + '"]:checked').length;
            } else {
                return $(this).val() === '';
            }
        });

        console.log(emptyInputs.length);

        if (emptyInputs.length === 0) {
            e.preventDefault();

            // Serialize form data

            var formData = $("#test-confirm").serialize();
            $.post('?room=test_confirm', formData)
                .done(function (response) {
                    // Handle successful response

                    /*
                        [correct_answers] => 6
                        [wrong_answers] => 9
                    */

                    if ($(this).data("popup-classes")) {
                        //$("#v-popup").attr("class", $(this).data("popup-classes"));
                    }

                    $("#v-popup").addClass("active");

                    $.post("?room=pratiba_test", { return_url: $(location).attr("pathname"), correct_answers: response.correct_answers, wrong_answers: response.wrong_answers, kad: response.kad }, function (data) {
                        $("#v-popup .content").html(data);

                        if (response.congratz == 1) {
                            /**
                             * Minified by jsDelivr using Terser v5.19.2.
                             * Original file: /npm/canvas-confetti@1.9.3/dist/confetti.browser.js
                             *
                             * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
                             */
                            !function (t, e) { !function t(e, a, n, r) { var o = !!(e.Worker && e.Blob && e.Promise && e.OffscreenCanvas && e.OffscreenCanvasRenderingContext2D && e.HTMLCanvasElement && e.HTMLCanvasElement.prototype.transferControlToOffscreen && e.URL && e.URL.createObjectURL), i = "function" == typeof Path2D && "function" == typeof DOMMatrix, l = function () { if (!e.OffscreenCanvas) return !1; var t = new OffscreenCanvas(1, 1), a = t.getContext("2d"); a.fillRect(0, 0, 1, 1); var n = t.transferToImageBitmap(); try { a.createPattern(n, "no-repeat") } catch (t) { return !1 } return !0 }(); function s() { } function c(t) { var n = a.exports.Promise, r = void 0 !== n ? n : e.Promise; return "function" == typeof r ? new r(t) : (t(s, s), null) } var h, f, u, d, m, g, p, b, M, v, y, w = (h = l, f = new Map, { transform: function (t) { if (h) return t; if (f.has(t)) return f.get(t); var e = new OffscreenCanvas(t.width, t.height); return e.getContext("2d").drawImage(t, 0, 0), f.set(t, e), e }, clear: function () { f.clear() } }), x = (m = Math.floor(1e3 / 60), g = {}, p = 0, "function" == typeof requestAnimationFrame && "function" == typeof cancelAnimationFrame ? (u = function (t) { var e = Math.random(); return g[e] = requestAnimationFrame((function a(n) { p === n || p + m - 1 < n ? (p = n, delete g[e], t()) : g[e] = requestAnimationFrame(a) })), e }, d = function (t) { g[t] && cancelAnimationFrame(g[t]) }) : (u = function (t) { return setTimeout(t, m) }, d = function (t) { return clearTimeout(t) }), { frame: u, cancel: d }), C = (v = {}, function () { if (b) return b; if (!n && o) { var e = ["var CONFETTI, SIZE = {}, module = {};", "(" + t.toString() + ")(this, module, true, SIZE);", "onmessage = function(msg) {", "  if (msg.data.options) {", "    CONFETTI(msg.data.options).then(function () {", "      if (msg.data.callback) {", "        postMessage({ callback: msg.data.callback });", "      }", "    });", "  } else if (msg.data.reset) {", "    CONFETTI && CONFETTI.reset();", "  } else if (msg.data.resize) {", "    SIZE.width = msg.data.resize.width;", "    SIZE.height = msg.data.resize.height;", "  } else if (msg.data.canvas) {", "    SIZE.width = msg.data.canvas.width;", "    SIZE.height = msg.data.canvas.height;", "    CONFETTI = module.exports.create(msg.data.canvas);", "  }", "}"].join("\n"); try { b = new Worker(URL.createObjectURL(new Blob([e]))) } catch (t) { return void 0 !== typeof console && "function" == typeof console.warn && console.warn("🎊 Could not load worker", t), null } !function (t) { function e(e, a) { t.postMessage({ options: e || {}, callback: a }) } t.init = function (e) { var a = e.transferControlToOffscreen(); t.postMessage({ canvas: a }, [a]) }, t.fire = function (a, n, r) { if (M) return e(a, null), M; var o = Math.random().toString(36).slice(2); return M = c((function (n) { function i(e) { e.data.callback === o && (delete v[o], t.removeEventListener("message", i), M = null, w.clear(), r(), n()) } t.addEventListener("message", i), e(a, o), v[o] = i.bind(null, { data: { callback: o } }) })) }, t.reset = function () { for (var e in t.postMessage({ reset: !0 }), v) v[e](), delete v[e] } }(b) } return b }), I = { particleCount: 50, angle: 90, spread: 45, startVelocity: 45, decay: .9, gravity: 1, drift: 0, ticks: 200, x: .5, y: .5, shapes: ["square", "circle"], zIndex: 100, colors: ["#26ccff", "#a25afd", "#ff5e7e", "#88ff5a", "#fcff42", "#ffa62d", "#ff36ff"], disableForReducedMotion: !1, scalar: 1 }; function T(t, e, a) { return function (t, e) { return e ? e(t) : t }(t && null != t[e] ? t[e] : I[e], a) } function E(t) { return t < 0 ? 0 : Math.floor(t) } function P(t) { return parseInt(t, 16) } function S(t) { return t.map(O) } function O(t) { var e = String(t).replace(/[^0-9a-f]/gi, ""); return e.length < 6 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), { r: P(e.substring(0, 2)), g: P(e.substring(2, 4)), b: P(e.substring(4, 6)) } } function k(t) { t.width = document.documentElement.clientWidth, t.height = document.documentElement.clientHeight } function B(t) { var e = t.getBoundingClientRect(); t.width = e.width, t.height = e.height } function F(t, e) { e.x += Math.cos(e.angle2D) * e.velocity + e.drift, e.y += Math.sin(e.angle2D) * e.velocity + e.gravity, e.velocity *= e.decay, e.flat ? (e.wobble = 0, e.wobbleX = e.x + 10 * e.scalar, e.wobbleY = e.y + 10 * e.scalar, e.tiltSin = 0, e.tiltCos = 0, e.random = 1) : (e.wobble += e.wobbleSpeed, e.wobbleX = e.x + 10 * e.scalar * Math.cos(e.wobble), e.wobbleY = e.y + 10 * e.scalar * Math.sin(e.wobble), e.tiltAngle += .1, e.tiltSin = Math.sin(e.tiltAngle), e.tiltCos = Math.cos(e.tiltAngle), e.random = Math.random() + 2); var a = e.tick++ / e.totalTicks, n = e.x + e.random * e.tiltCos, r = e.y + e.random * e.tiltSin, o = e.wobbleX + e.random * e.tiltCos, l = e.wobbleY + e.random * e.tiltSin; if (t.fillStyle = "rgba(" + e.color.r + ", " + e.color.g + ", " + e.color.b + ", " + (1 - a) + ")", t.beginPath(), i && "path" === e.shape.type && "string" == typeof e.shape.path && Array.isArray(e.shape.matrix)) t.fill(function (t, e, a, n, r, o, i) { var l = new Path2D(t), s = new Path2D; s.addPath(l, new DOMMatrix(e)); var c = new Path2D; return c.addPath(s, new DOMMatrix([Math.cos(i) * r, Math.sin(i) * r, -Math.sin(i) * o, Math.cos(i) * o, a, n])), c }(e.shape.path, e.shape.matrix, e.x, e.y, .1 * Math.abs(o - n), .1 * Math.abs(l - r), Math.PI / 10 * e.wobble)); else if ("bitmap" === e.shape.type) { var s = Math.PI / 10 * e.wobble, c = .1 * Math.abs(o - n), h = .1 * Math.abs(l - r), f = e.shape.bitmap.width * e.scalar, u = e.shape.bitmap.height * e.scalar, d = new DOMMatrix([Math.cos(s) * c, Math.sin(s) * c, -Math.sin(s) * h, Math.cos(s) * h, e.x, e.y]); d.multiplySelf(new DOMMatrix(e.shape.matrix)); var m = t.createPattern(w.transform(e.shape.bitmap), "no-repeat"); m.setTransform(d), t.globalAlpha = 1 - a, t.fillStyle = m, t.fillRect(e.x - f / 2, e.y - u / 2, f, u), t.globalAlpha = 1 } else if ("circle" === e.shape) t.ellipse ? t.ellipse(e.x, e.y, Math.abs(o - n) * e.ovalScalar, Math.abs(l - r) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI) : function (t, e, a, n, r, o, i, l, s) { t.save(), t.translate(e, a), t.rotate(o), t.scale(n, r), t.arc(0, 0, 1, i, l, s), t.restore() }(t, e.x, e.y, Math.abs(o - n) * e.ovalScalar, Math.abs(l - r) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI); else if ("star" === e.shape) for (var g = Math.PI / 2 * 3, p = 4 * e.scalar, b = 8 * e.scalar, M = e.x, v = e.y, y = 5, x = Math.PI / y; y--;)M = e.x + Math.cos(g) * b, v = e.y + Math.sin(g) * b, t.lineTo(M, v), g += x, M = e.x + Math.cos(g) * p, v = e.y + Math.sin(g) * p, t.lineTo(M, v), g += x; else t.moveTo(Math.floor(e.x), Math.floor(e.y)), t.lineTo(Math.floor(e.wobbleX), Math.floor(r)), t.lineTo(Math.floor(o), Math.floor(l)), t.lineTo(Math.floor(n), Math.floor(e.wobbleY)); return t.closePath(), t.fill(), e.tick < e.totalTicks } function A(t, a) { var i, l = !t, s = !!T(a || {}, "resize"), h = !1, f = T(a, "disableForReducedMotion", Boolean), u = o && !!T(a || {}, "useWorker") ? C() : null, d = l ? k : B, m = !(!t || !u) && !!t.__confetti_initialized, g = "function" == typeof matchMedia && matchMedia("(prefers-reduced-motion)").matches; function p(e, a, o) { for (var l, s, h, f, u, m = T(e, "particleCount", E), g = T(e, "angle", Number), p = T(e, "spread", Number), b = T(e, "startVelocity", Number), M = T(e, "decay", Number), v = T(e, "gravity", Number), y = T(e, "drift", Number), C = T(e, "colors", S), I = T(e, "ticks", Number), P = T(e, "shapes"), O = T(e, "scalar"), k = !!T(e, "flat"), B = function (t) { var e = T(t, "origin", Object); return e.x = T(e, "x", Number), e.y = T(e, "y", Number), e }(e), A = m, R = [], N = t.width * B.x, z = t.height * B.y; A--;)R.push((l = { x: N, y: z, angle: g, spread: p, startVelocity: b, color: C[A % C.length], shape: P[(f = 0, u = P.length, Math.floor(Math.random() * (u - f)) + f)], ticks: I, decay: M, gravity: v, drift: y, scalar: O, flat: k }, s = void 0, h = void 0, s = l.angle * (Math.PI / 180), h = l.spread * (Math.PI / 180), { x: l.x, y: l.y, wobble: 10 * Math.random(), wobbleSpeed: Math.min(.11, .1 * Math.random() + .05), velocity: .5 * l.startVelocity + Math.random() * l.startVelocity, angle2D: -s + (.5 * h - Math.random() * h), tiltAngle: (.5 * Math.random() + .25) * Math.PI, color: l.color, shape: l.shape, tick: 0, totalTicks: l.ticks, decay: l.decay, drift: l.drift, random: Math.random() + 2, tiltSin: 0, tiltCos: 0, wobbleX: 0, wobbleY: 0, gravity: 3 * l.gravity, ovalScalar: .6, scalar: l.scalar, flat: l.flat })); return i ? i.addFettis(R) : (i = function (t, e, a, o, i) { var l, s, h = e.slice(), f = t.getContext("2d"), u = c((function (e) { function c() { l = s = null, f.clearRect(0, 0, o.width, o.height), w.clear(), i(), e() } l = x.frame((function e() { !n || o.width === r.width && o.height === r.height || (o.width = t.width = r.width, o.height = t.height = r.height), o.width || o.height || (a(t), o.width = t.width, o.height = t.height), f.clearRect(0, 0, o.width, o.height), (h = h.filter((function (t) { return F(f, t) }))).length ? l = x.frame(e) : c() })), s = c })); return { addFettis: function (t) { return h = h.concat(t), u }, canvas: t, promise: u, reset: function () { l && x.cancel(l), s && s() } } }(t, R, d, a, o), i.promise) } function b(a) { var n = f || T(a, "disableForReducedMotion", Boolean), r = T(a, "zIndex", Number); if (n && g) return c((function (t) { t() })); l && i ? t = i.canvas : l && !t && (t = function (t) { var e = document.createElement("canvas"); return e.style.position = "fixed", e.style.top = "0px", e.style.left = "0px", e.style.pointerEvents = "none", e.style.zIndex = t, e }(r), document.body.appendChild(t)), s && !m && d(t); var o = { width: t.width, height: t.height }; function b() { if (u) { var e = { getBoundingClientRect: function () { if (!l) return t.getBoundingClientRect() } }; return d(e), void u.postMessage({ resize: { width: e.width, height: e.height } }) } o.width = o.height = null } function M() { i = null, s && (h = !1, e.removeEventListener("resize", b)), l && t && (document.body.contains(t) && document.body.removeChild(t), t = null, m = !1) } return u && !m && u.init(t), m = !0, u && (t.__confetti_initialized = !0), s && !h && (h = !0, e.addEventListener("resize", b, !1)), u ? u.fire(a, o, M) : p(a, o, M) } return b.reset = function () { u && u.reset(), i && i.reset() }, b } function R() { return y || (y = A(null, { useWorker: !0, resize: !0 })), y } a.exports = function () { return R().apply(this, arguments) }, a.exports.reset = function () { R().reset() }, a.exports.create = A, a.exports.shapeFromPath = function (t) { if (!i) throw new Error("path confetti are not supported in this browser"); var e, a; "string" == typeof t ? e = t : (e = t.path, a = t.matrix); var n = new Path2D(e), r = document.createElement("canvas").getContext("2d"); if (!a) { for (var o, l, s = 1e3, c = s, h = s, f = 0, u = 0, d = 0; d < s; d += 2)for (var m = 0; m < s; m += 2)r.isPointInPath(n, d, m, "nonzero") && (c = Math.min(c, d), h = Math.min(h, m), f = Math.max(f, d), u = Math.max(u, m)); o = f - c, l = u - h; var g = Math.min(10 / o, 10 / l); a = [g, 0, 0, g, -Math.round(o / 2 + c) * g, -Math.round(l / 2 + h) * g] } return { type: "path", path: e, matrix: a } }, a.exports.shapeFromText = function (t) { var e, a = 1, n = "#000000", r = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif'; "string" == typeof t ? e = t : (e = t.text, a = "scalar" in t ? t.scalar : a, r = "fontFamily" in t ? t.fontFamily : r, n = "color" in t ? t.color : n); var o = 10 * a, i = o + "px " + r, l = new OffscreenCanvas(o, o), s = l.getContext("2d"); s.font = i; var c = s.measureText(e), h = Math.ceil(c.actualBoundingBoxRight + c.actualBoundingBoxLeft), f = Math.ceil(c.actualBoundingBoxAscent + c.actualBoundingBoxDescent), u = c.actualBoundingBoxLeft + 2, d = c.actualBoundingBoxAscent + 2; h += 4, f += 4, (s = (l = new OffscreenCanvas(h, f)).getContext("2d")).font = i, s.fillStyle = n, s.fillText(e, u, d); var m = 1 / a; return { type: "bitmap", bitmap: l.transferToImageBitmap(), matrix: [m, 0, 0, m, -h * m / 2, -f * m / 2] } } }(function () { return void 0 !== t ? t : "undefined" != typeof self ? self : this || {} }(), e, !1), t.confetti = e.exports }(window, {});
                            //# sourceMappingURL=/sm/0e9ac22f62a550282b886b288da51d7892173a94bbd286c2ffc6e7b881509c88.map
                            //confetti({})

                            var duration = 15 * 1000;
                            var animationEnd = Date.now() + duration;
                            var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

                            function randomInRange(min, max) {
                                return Math.random() * (max - min) + min;
                            }

                            var interval = setInterval(function () {
                                var timeLeft = animationEnd - Date.now();

                                if (timeLeft <= 0) {
                                    return clearInterval(interval);
                                }

                                var particleCount = 50 * (timeLeft / duration);
                                // since particles fall down, start a bit higher than random
                                confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }, zIndex: 99999999 });
                                confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }, zIndex: 99999999 });
                            }, 250);

                        }

                        $(".cancel-vpopup").click(function (e) {
                            $("#v-popup .content").html("");
                            $("#v-popup").removeClass("active");
                        });
                    });

                })
                .fail(function (xhr, status, error) {
                    // Handle error
                });
        }



    });

});
